import supabase from './supabaseClient';

// Technology Platforms Service
export const technologyService = {
  // Get all technology platforms for the current user
  getAll: async () => {
    const { data, error } = await supabase
      .from('technology_platforms')
      .select('*')
      .order('name');
    
    if (error) throw error;
    return data;
  },
  
  // Get a specific technology platform by ID
  getById: async (id) => {
    const { data, error } = await supabase
      .from('technology_platforms')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data;
  },
  
  // Create a new technology platform
  create: async (technology) => {
    const { data, error } = await supabase
      .from('technology_platforms')
      .insert([technology])
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Update a technology platform
  update: async (id, technology) => {
    const { data, error } = await supabase
      .from('technology_platforms')
      .update(technology)
      .eq('id', id)
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Delete a technology platform
  delete: async (id) => {
    const { error } = await supabase
      .from('technology_platforms')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
    return true;
  },

  // Get technologies for a specific product
  getByProductId: async (productId) => {
    const { data, error } = await supabase
      .from('product_technologies')
      .select(`
        technology_id,
        technology_platforms:technology_id (*)
      `)
      .eq('product_id', productId);
    
    if (error) throw error;
    return data.map(item => item.technology_platforms);
  },

  // Add technology to a product
  addToProduct: async (productId, technologyId) => {
    const { data, error } = await supabase
      .from('product_technologies')
      .insert([{ product_id: productId, technology_id: technologyId }])
      .select();
    
    if (error) throw error;
    return data[0];
  },

  // Remove technology from a product
  removeFromProduct: async (productId, technologyId) => {
    const { error } = await supabase
      .from('product_technologies')
      .delete()
      .eq('product_id', productId)
      .eq('technology_id', technologyId);
    
    if (error) throw error;
    return true;
  }
};

// Assets Service
export const assetService = {
  // Get all assets for the current user
  getAll: async () => {
    const { data, error } = await supabase
      .from('assets')
      .select('*')
      .order('name');
    
    if (error) throw error;
    return data;
  },
  
  // Get a specific asset by ID
  getById: async (id) => {
    const { data, error } = await supabase
      .from('assets')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data;
  },
  
  // Create a new asset
  create: async (asset) => {
    const { data, error } = await supabase
      .from('assets')
      .insert([asset])
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Update an asset
  update: async (id, asset) => {
    const { data, error } = await supabase
      .from('assets')
      .update(asset)
      .eq('id', id)
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Delete an asset
  delete: async (id) => {
    const { error } = await supabase
      .from('assets')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
    return true;
  },

  // Get assets for a specific product
  getByProductId: async (productId) => {
    const { data, error } = await supabase
      .from('product_assets')
      .select(`
        asset_id,
        assets:asset_id (*)
      `)
      .eq('product_id', productId);
    
    if (error) throw error;
    return data.map(item => item.assets);
  },

  // Add asset to a product
  addToProduct: async (productId, assetId) => {
    const { data, error } = await supabase
      .from('product_assets')
      .insert([{ product_id: productId, asset_id: assetId }])
      .select();
    
    if (error) throw error;
    return data[0];
  },

  // Remove asset from a product
  removeFromProduct: async (productId, assetId) => {
    const { error } = await supabase
      .from('product_assets')
      .delete()
      .eq('product_id', productId)
      .eq('asset_id', assetId);
    
    if (error) throw error;
    return true;
  }
};

// Patents Service
export const patentService = {
  // Get all patents for the current user
  getAll: async () => {
    const { data, error } = await supabase
      .from('patents')
      .select('*')
      .order('name');
    
    if (error) throw error;
    return data;
  },
  
  // Get a specific patent by ID
  getById: async (id) => {
    const { data, error } = await supabase
      .from('patents')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data;
  },
  
  // Create a new patent
  create: async (patent) => {
    const { data, error } = await supabase
      .from('patents')
      .insert([patent])
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Update a patent
  update: async (id, patent) => {
    const { data, error } = await supabase
      .from('patents')
      .update(patent)
      .eq('id', id)
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Delete a patent
  delete: async (id) => {
    const { error } = await supabase
      .from('patents')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
    return true;
  },

  // Get patents for a specific product
  getByProductId: async (productId) => {
    const { data, error } = await supabase
      .from('product_patents')
      .select(`
        patent_id,
        patents:patent_id (*)
      `)
      .eq('product_id', productId);
    
    if (error) throw error;
    return data.map(item => item.patents);
  },

  // Add patent to a product
  addToProduct: async (productId, patentId) => {
    const { data, error } = await supabase
      .from('product_patents')
      .insert([{ product_id: productId, patent_id: patentId }])
      .select();
    
    if (error) throw error;
    return data[0];
  },

  // Remove patent from a product
  removeFromProduct: async (productId, patentId) => {
    const { error } = await supabase
      .from('product_patents')
      .delete()
      .eq('product_id', productId)
      .eq('patent_id', patentId);
    
    if (error) throw error;
    return true;
  }
};

// Team Members Service
export const teamMemberService = {
  // Get all team members for the current user
  getAll: async () => {
    const { data, error } = await supabase
      .from('team_members')
      .select('*')
      .order('name');
    
    if (error) throw error;
    return data;
  },
  
  // Get a specific team member by ID
  getById: async (id) => {
    const { data, error } = await supabase
      .from('team_members')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data;
  },
  
  // Create a new team member
  create: async (teamMember) => {
    const { data, error } = await supabase
      .from('team_members')
      .insert([teamMember])
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Update a team member
  update: async (id, teamMember) => {
    const { data, error } = await supabase
      .from('team_members')
      .update(teamMember)
      .eq('id', id)
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Delete a team member
  delete: async (id) => {
    const { error } = await supabase
      .from('team_members')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
    return true;
  },

  // Get team members for a specific product
  getByProductId: async (productId) => {
    const { data, error } = await supabase
      .from('product_team_members')
      .select(`
        team_member_id,
        team_members:team_member_id (*)
      `)
      .eq('product_id', productId);
    
    if (error) throw error;
    return data.map(item => item.team_members);
  },

  // Add team member to a product
  addToProduct: async (productId, teamMemberId) => {
    const { data, error } = await supabase
      .from('product_team_members')
      .insert([{ product_id: productId, team_member_id: teamMemberId }])
      .select();
    
    if (error) throw error;
    return data[0];
  },

  // Remove team member from a product
  removeFromProduct: async (productId, teamMemberId) => {
    const { error } = await supabase
      .from('product_team_members')
      .delete()
      .eq('product_id', productId)
      .eq('team_member_id', teamMemberId);
    
    if (error) throw error;
    return true;
  }
};

// Funding Service
export const fundingService = {
  // Get all funding for the current user
  getAll: async () => {
    const { data, error } = await supabase
      .from('funding')
      .select('*')
      .order('date_received', { ascending: false });
    
    if (error) throw error;
    return data;
  },
  
  // Get a specific funding by ID
  getById: async (id) => {
    const { data, error } = await supabase
      .from('funding')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data;
  },
  
  // Create a new funding
  create: async (funding) => {
    const { data, error } = await supabase
      .from('funding')
      .insert([funding])
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Update a funding
  update: async (id, funding) => {
    const { data, error } = await supabase
      .from('funding')
      .update(funding)
      .eq('id', id)
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Delete a funding
  delete: async (id) => {
    const { error } = await supabase
      .from('funding')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
    return true;
  },

  // Get funding for a specific product
  getByProductId: async (productId) => {
    const { data, error } = await supabase
      .from('product_funding')
      .select(`
        funding_id,
        funding:funding_id (*)
      `)
      .eq('product_id', productId);
    
    if (error) throw error;
    return data.map(item => item.funding);
  },

  // Add funding to a product
  addToProduct: async (productId, fundingId) => {
    const { data, error } = await supabase
      .from('product_funding')
      .insert([{ product_id: productId, funding_id: fundingId }])
      .select();
    
    if (error) throw error;
    return data[0];
  },

  // Remove funding from a product
  removeFromProduct: async (productId, fundingId) => {
    const { error } = await supabase
      .from('product_funding')
      .delete()
      .eq('product_id', productId)
      .eq('funding_id', fundingId);
    
    if (error) throw error;
    return true;
  }
};

// Spending Service
export const spendingService = {
  // Get all spending for the current user
  getAll: async () => {
    const { data, error } = await supabase
      .from('spending')
      .select('*')
      .order('date_spent', { ascending: false });
    
    if (error) throw error;
    return data;
  },
  
  // Get a specific spending by ID
  getById: async (id) => {
    const { data, error } = await supabase
      .from('spending')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data;
  },
  
  // Create a new spending
  create: async (spending) => {
    const { data, error } = await supabase
      .from('spending')
      .insert([spending])
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Update a spending
  update: async (id, spending) => {
    const { data, error } = await supabase
      .from('spending')
      .update(spending)
      .eq('id', id)
      .select();
    
    if (error) throw error;
    return data[0];
  },
  
  // Delete a spending
  delete: async (id) => {
    const { error } = await supabase
      .from('spending')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
    return true;
  },

  // Get spending for a specific product
  getByProductId: async (productId) => {
    const { data, error } = await supabase
      .from('product_spending')
      .select(`
        spending_id,
        spending:spending_id (*)
      `)
      .eq('product_id', productId);
    
    if (error) throw error;
    return data.map(item => item.spending);
  },

  // Add spending to a product
  addToProduct: async (productId, spendingId) => {
    const { data, error } = await supabase
      .from('product_spending')
      .insert([{ product_id: productId, spending_id: spendingId }])
      .select();
    
    if (error) throw error;
    return data[0];
  },

  // Remove spending from a product
  removeFromProduct: async (productId, spendingId) => {
    const { error } = await supabase
      .from('product_spending')
      .delete()
      .eq('product_id', productId)
      .eq('spending_id', spendingId);
    
    if (error) throw error;
    return true;
  }
}; 